import script from "./AppInfoMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AppInfoMessage.vue?vue&type=script&setup=true&lang=js"

import "./AppInfoMessage.vue?vue&type=style&index=0&id=50371f6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50371f6c"]])

export default __exports__